// messages from reusable persona popup window to main flow
export const CREATE_PERSONA_MESSAGES = {
  CREATED: 'create-persona/created',
  DISMISSED: 'create-persona/dismissed',
};

// messages from reusable persona popup window to main flow
export const VERIFY_WITH_PERSONA_MESSAGES = {
  // transition has started, if popup window is closed in this state, main flow should poll for updated inquiry
  // as it will no longer receive any other messages
  TRANSITION_STARTED: 'verify-with-persona/transition-started',
  // first transition call has completed and inquiry is polling, main flow should begin polling as well
  TRANSITION_POLLING: 'verify-with-persona/transition-polling',
  // transition is completed inside the reusable persona popup window, main flow should begin polling if previous state was submitted
  TRANSITION_COMPLETED: 'verify-with-persona/transition-completed',
  // transition has erroed inside the reusable persona popup window, main flow should begin polling
  TRANSITION_ERRORED: 'verify-with-persona/transition-errored',
};

export const CREATE_PERSONA_POPUP_ROUTE = '/inquiry/reusable-persona-create-popup';
export const VERIFY_WITH_PERSONA_POPUP_ROUTE = '/inquiry/reusable-persona-verify-popup';
